import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import type { Pane } from './useMessagesView';

/**
 * Editor und Vorschau. Breit nebeneinander; schmaler wählt „Bearbeiten | Vorschau", welche der
 * beiden zu sehen ist — beide bleiben dasselbe Bauteil, nur die Breite entscheidet.
 */
export function MessageWorkspace({
  editor,
  preview,
  view,
  onViewChange,
}: {
  editor: ReactNode;
  preview: ReactNode;
  view: Pane;
  onViewChange: (view: Pane) => void;
}) {
  return (
    <div className="@container">
      <div
        role="group"
        aria-label="Ansicht"
        className="bg-card-alt/60 @4xl:hidden mb-3 inline-flex rounded-lg p-1"
      >
        {(
          [
            ['edit', 'Bearbeiten'],
            ['preview', 'Vorschau'],
          ] as const
        ).map(([key, label]) => (
          <button
            key={key}
            type="button"
            aria-pressed={view === key}
            onClick={() => onViewChange(key)}
            className={cn(
              'focus-visible:outline-sage min-h-11 rounded-md px-5 text-sm font-semibold focus-visible:outline focus-visible:outline-2',
              view === key ? 'bg-navy text-paper' : 'text-ink-soft hover:text-ink',
            )}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="@4xl:grid-cols-[minmax(0,1fr)_minmax(20rem,24rem)] grid grid-cols-1 items-start gap-5">
        <div className={cn('@4xl:block min-w-0', view === 'preview' && 'hidden')}>{editor}</div>
        <div
          className={cn('@4xl:sticky @4xl:top-4 @4xl:block min-w-0', view === 'edit' && 'hidden')}
        >
          {preview}
        </div>
      </div>
    </div>
  );
}
